import styled from 'styled-components';
import {DialogActions} from '@material-ui/core';

export const DialogActionsStyled = styled(DialogActions)`
  justify-content: flex-start;
  padding: 30px;
  background-color: #f8f8f9;
`;
